import React from 'react';
import { IconNavQueue } from '../../../../components/Icons';
import ReportQueueModule from './ReportQueueModule';

/**
 * Report Queue Module Configuration
 *
 * Displays queue requests relevant to the active report in the right panel.
 */
const reportQueueModuleConfig = {
  id: 'report-queue',
  name: 'Report Queue',
  icon: <IconNavQueue />,
  component: ReportQueueModule,
  enabled: true,
  expandEnabled: true,
  notListOnModuleBrowser: true,
  order: 4,
};

export default reportQueueModuleConfig;
